import React from "react";
import { css } from "@emotion/react";
import { useTranslation } from "react-i18next";
import { useAppSelector } from "main/javascripts/store";
import { cruiseDestinationRegionsSelector } from "../cruiseSlice";
import { space } from "main/javascripts/styles/base/spaceStyle";
import {
  fontSize,
  lineHeight,
} from "main/javascripts/styles/base/typographyStyle";
import { RegionList } from "main/javascripts/components/lp/RegionList";

export const CruiseDestinationRegionList: React.FC = (): React.ReactElement => {
  const { t } = useTranslation(["component"]);

  const destinationRegions = useAppSelector(cruiseDestinationRegionsSelector);

  const listItems = destinationRegions.map((region) => {
    return {
      text: region.name,
      url: `/cruise_dst/${region.id}`,
    };
  });

  return (
    <div css={blockStyle}>
      <h2 css={titleStyle}>{t("cruise.destinationRegions")}</h2>
      <div css={regionListStyle}>
        <RegionList listItems={listItems} />
      </div>
    </div>
  );
};

const blockStyle = css`
  width: 100%;
`;
const titleStyle = css`
  font-size: ${fontSize.headline};
  line-height: ${lineHeight.headline2};
  padding: ${space.atom2x} 0;
`;
const regionListStyle = css`
  padding: ${space.atom2_5x} 0;
`;
